import type {
  FunnelChartData,
  FunnelStage,
  CheckoutFunnelStats,
} from '../products/models/product-checkout-stats';

export function mapOverallCheckoutToFunnelData(checkoutData: CheckoutFunnelStats): FunnelChartData {
  const stage1: FunnelStage = {
    id: 1,
    name: 'Carts Created',
    value: checkoutData.total_carts_created,
    customerCount: checkoutData.total_carts_created_customer_count,
    description: 'Customers who created a shopping cart',
    color: 'var(--color-green-90)',
    strokeColor: 'var(--primary-30)',
  };

  const stage2: FunnelStage = {
    id: 2,
    name: 'Address Added',
    value: checkoutData.carts_with_address_added,
    customerCount: checkoutData.carts_with_address_added_customer_count,
    previousStage: stage1,
    description: 'Customers who added a shipping address',
    color: 'var(--color-green-90)',
    strokeColor: 'var(--primary-30)',
  };

  const stage3: FunnelStage = {
    id: 3,
    name: 'Orders Created',
    value: checkoutData.total_orders_created,
    customerCount: checkoutData.total_orders_created_customer_count,
    previousStage: stage2,
    description: 'Customers who created an order by proceeding to payment',
    color: 'var(--color-green-90)',
    strokeColor: 'var(--primary-30)',
  };

  const stage4: FunnelStage = {
    id: 4,
    name: 'Orders Completed',
    value: checkoutData.total_orders_completed,
    customerCount: checkoutData.total_orders_completed_customer_count,
    previousStage: stage3,
    description: 'Customers who completed their order by completing payment successfully',
    color: 'var(--color-green-90)',
    strokeColor: 'var(--primary-30)',
  };

  const overallConversion = stage1.customerCount
    ? (stage4.customerCount / stage1.customerCount) * 100
    : 0;

  return {
    stages: [stage1, stage2, stage3, stage4],
    overallConversion: parseFloat(overallConversion.toFixed(2)),
  };
}
